import React from 'react';
import PropTypes from 'prop-types';

import SrPartnerList from 'client/components/SrPartnerList';
import SrPartnerSection from 'client/components/SrPartnerSection';
import SrPartnerHouseholdStartApplicationCard from 'client/components/SrPartnerHouseholdStartApplicationCard';

const SrPartnerListingPageTenantScreeningHouseholdsStartedApplying = ({
  householdsApplying,
}) => {
  const {
    households,
  } = householdsApplying;

  if (!households?.length) {
    return null;
  }

  return (
    <>
      <SrPartnerSection title='Started Applications'>
        <SrPartnerList>
          {households.map((household) => {
            return (
              <SrPartnerHouseholdStartApplicationCard
                key={household.id}
                household={household}
                users={[...household.renters, ...household.guarantors]}
                renterApplications={household.householdApplications}
                guarantorsApplications={household.guarantorApplications}
              />
            );
          })}
        </SrPartnerList>
      </SrPartnerSection>
    </>
  );
};

SrPartnerListingPageTenantScreeningHouseholdsStartedApplying.propTypes = {
  householdsApplying: PropTypes.object.isRequired,
};

SrPartnerListingPageTenantScreeningHouseholdsStartedApplying
  .displayName = 'SrPartnerListingPageTenantScreeningHouseholdsStartedApplying';

export default SrPartnerListingPageTenantScreeningHouseholdsStartedApplying;
